/* eslint-disable react/no-array-index-key */
import {
  Box, CircularProgress, Grid, Paper,
} from '@mui/material';
import { IProduct } from 'types/productType';
import { BASEURL } from 'context/context';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Product } from '../../../../components/Product/Product';

export type IProductListProps = {

}

const ProductList: React.FC<IProductListProps> = ({ }) => {
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchProducts = async () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const startIndex = products.length === 0
      ? 0
      : parseInt(products[products.length - 1].uid, 10) + 1;

    const raw = JSON.stringify({
      startIndex,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    setLoading(true);
    const fetchProductResults = await fetch(`${BASEURL}/allProducts`, requestOptions as any);
    const productResults = await fetchProductResults.json();
    setLoading(false);

    setProducts([...products, ...productResults]);
  };

  const handleScroll = async (event: SyntheticEvent) => {
    if (loading) return;

    const listboxNode = event.currentTarget;
    const position = listboxNode.scrollTop + listboxNode.clientHeight;
    if (listboxNode.scrollHeight - position <= 1) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      console.log('fetching more products');
      await fetchProducts();
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          height: '98vh',
          overflowY: 'scroll',
        }}
        onScroll={handleScroll}
      >

        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {products.map((product) => (
            <Grid item xs={2} sm={4} md={4} key={product.uid}>
              <Product product={product} />
            </Grid>
          ))}
        </Grid>
      </Box>

      {loading ? (
        <Box sx={{ position: 'relative', boxSizing: 'border-box' }}>
          <Paper
            sx={{
              position: 'absolute',
              zIndex: '1',
              bottom: '55px',
              left: '50%',
              width: '30px',
              height: '30px',
              p: '5px',
              borderRadius: '50%',
            }}
          >
            <CircularProgress
              size="30px"
              color="secondary"
              thickness={6}
            />
          </Paper>
        </Box>
      ) : null}
    </Box>
  );
};

export { ProductList };
